<template>
  <div class="reset-password">

    <form class="reset-password">

      <byjove-logo :appsettings="appsettings"
                   style="text-align: center;">
      </byjove-logo>

      <b-field label="New Password">
        <b-input v-model="password" type="password" />
      </b-field>

      <b-field label="Confirm Password">
        <b-input v-model="confirmPassword" type="password" />
      </b-field>

      <div class="buttons">
        <b-button type="is-primary"
                  @click="attemptResetPassword()"
                  :disabled="resetPasswordFormDisabled">
          Submit
        </b-button>
      </div>
    </form>

  </div>
</template>

<script>
import appsettings from '@/appsettings'
import {ByjoveLogo} from 'byjove'

export default {
    name: 'ResetPassword',
    components: {
        ByjoveLogo,
    },
    data: function () {
        return {
            appsettings: appsettings,
            password: null,
            confirmPassword: null,
        }
    },
    computed: {
        resetPasswordFormDisabled: function() {
            if (!this.password) {
                return true
            }
            if (!this.confirmPassword) {
                return true
            }
            if (this.confirmPassword != this.password) {
                return true
            }
            return false
        },
    },
    created: function() {
        this.checkUser()
    },
    watch: {
        '$store.state.session_established': 'checkUser',
    },
    methods: {

        checkUser() {
            if (this.$store.state.session_established) {

                // send logged-in users to "home" instead
                if (this.$store.state.user.uuid) {
                    this.$router.push('/benefits')

                } else if (!this.$route.query.uid || !this.$route.query.token) {
                    // we're missing required params, *and* user is logged out,
                    // so just send them back to "login" page instead
                    this.$router.push('/login')
                }
            }
        },

        attemptResetPassword: function() {
            let params = {
                uid: this.$route.query.uid,
                access_token: this.$route.query.token,
                password: this.password,
            }

            this.$http.post('/api/reset-password', params).then(response => {
                if (response.data.ok) {
                    this.$store.commit('SET_USER', response.data.user);
                    this.$router.push('/benefits')
                    this.$buefy.toast.open({
                        message: "Your password has been updated!",
                        type: 'is-success',
                        duration: 4000, // 4 seconds
                    })
                } else {
                    this.$buefy.toast.open({
                        message: response.data.error || "something went wrong!",
                        type: 'is-danger',
                        duration: 10000, // 10 seconds
                    })
                }
            })
        },
    }
}
</script>

<style>
form.reset-password {
    max-width: 25rem;
    margin: 2rem auto;
}
</style>
